import { useAppContext } from 'components/Context/AppContext';
import { Button } from 'components/Global';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';
import { createOrder } from 'features/orders/actions';
import { resetData } from 'features/orders/createOrder';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { normalizeTimeFormat, setCurrency } from 'utils/functionality';

const DetailPesananComponent = ({
  prevPage,
  currency = 'IDR',
  selectedCar,
  orderData,
  allAreaCharter,
  allRentTime,
  selectedAdditionalItem,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { setShowConfirmation, showToast } = useAppContext();

  const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);
  const { data: rentalServicesData } = useSelector((state) => state.services);

  const submitHandler = () => {
    const createOrderCharter = async () => {
      const orderBookingZone = [...allAreaCharter]
        .map((area, index) => ({
          ...area,
          charter_duration: allRentTime[index]?.charter_duration?.duration,
          booking_start_time: normalizeTimeFormat(allRentTime[index]?.booking_start_time),
          booking_end_time: normalizeTimeFormat(allRentTime[index]?.booking_end_time),
        }))
        .map((area) => ({
          ...area,
          endLocation: undefined,
          startLocation: undefined,
          sameLocation: undefined,
        }));

      const serviceSewaMobil = rentalServicesData.find((item) => item.name === 'Sewa Mobil');

      const service_id = serviceSewaMobil?.id;
      const sub_service_id = rentalServicesData
        ?.find((item) => item.id === service_id)
        ?.sub_services?.find((item) => item.name === 'Daily')
        ?.facilities?.find((item) => item.name === 'Charter')?.id;

      let mappingAdditionalItem = [];

      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const payload = {
        ...orderData,
        order_detail: {
          ...orderData.order_detail,
          booking_zones: orderBookingZone,
          sub_services_id: sub_service_id,
          start_booking_time: allRentTime[0]?.booking_start_time,
          end_booking_time: allRentTime[allRentTime?.length - 1]?.booking_end_time,
        },
        addons: mappingAdditionalItem,
        dp_rule_id: summaryOrderData?.minimal_dp_rule?.id,
        remainder: orderData.type === 'HALF' ? summaryOrderData?.remainder : 0,
        price_per_day: summaryOrderData?.price_per_day,
        exceed_passenger_price: summaryOrderData?.exced_max_passenger_charge,
        down_payment: orderData.type === 'HALF' ? summaryOrderData?.total_dp : 0,
        one_day_order_charge: summaryOrderData?.one_day_order_charge,
        outside_operational_charge: summaryOrderData?.outside_operational_charge,
      };

      setShowConfirmation({
        message: 'Apakah anda yakin ingin lanjut melakukan proses transaksi?',
        show: true,
        onClick: async () => {
          try {
            await dispatch(createOrder(payload)).unwrap();

            navigate(`/car-charter?status=ALL&locationId=${orderData.order_detail.location_id}`);

            showToast({ type: 'success', message: 'Berhasil Proses Transaksi' });
            dispatch(resetData());
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            showToast({ type: 'error', message: 'Proses Transaksi Gagal' });
          }
        },
      });
    };

    createOrderCharter();
  };

  return (
    <div className="detail-pesanan-car-charter">
      <h2>Detail Pesanan</h2>

      <div className="detail-pesanan-car-charter__rincian">
        <div className="rental-data">
          <h3>
            {selectedCar?.brand_name && <span>{selectedCar?.brand_name} </span>}
            <span>{selectedCar?.name}</span>
          </h3>
          <ul className="rental-data__list">
            <li>
              <p>Tanggal Mulai Sewa</p>
              <p>
                {summaryOrderData?.start_booking_date
                  ? format(new Date(summaryOrderData.start_booking_date), 'dd MMMM yyyy', { locale: id })
                  : ''}
              </p>
            </li>
            <li>
              <p>Jam Mulai</p>
              <p>
                {summaryOrderData?.start_booking_time && summaryOrderData?.start_booking_date
                  ? format(
                      new Date(`${summaryOrderData.start_booking_date} ${summaryOrderData.start_booking_time}`),
                      'hh:mm a',
                      { locale: id },
                    )
                  : ''}
              </p>
            </li>
            <li>
              <p>Tanggal Selesai</p>
              <p>
                {summaryOrderData?.end_booking_date
                  ? format(new Date(summaryOrderData.end_booking_date), 'dd MMMM yyyy', { locale: id })
                  : ''}
              </p>
            </li>
          </ul>
        </div>

        <div className="rental-fee">
          <div className="order-fee">
            <h3>Biaya Sewa</h3>
            <ul className="rental-data__list">
              <li>
                <p>Harga</p>
                <p>
                  {summaryOrderData?.booking_price ? setCurrency(summaryOrderData.booking_price, currency) : 'IDR 0'}{' '}
                  (All-In)
                </p>
              </li>
              {summaryOrderData?.addons &&
                summaryOrderData.addons.map((add) => (
                  <li key={add.id}>
                    <p>
                      {add.name} {`(${add.varieties?.[0]?.color})`} {`${add.varieties?.[0]?.quantity}x`}
                    </p>
                    <p>
                      {add.varieties?.[0]?.total_price
                        ? setCurrency(add.varieties?.[0]?.total_price, currency)
                        : 'IDR 0'}{' '}
                      {`(${summaryOrderData?.order_zone_price?.length} Hari)`}
                    </p>
                  </li>
                ))}
            </ul>
          </div>

          <div className="other-fee">
            <h3>Biaya Lainnya</h3>
            <ul className="rental-data__list">
              <li>
                <p>Biaya Layanan</p>
                <p>
                  {summaryOrderData?.service_fee
                    ? setCurrency(summaryOrderData?.service_fee, currency)
                    : setCurrency(0, currency)}
                </p>
              </li>
              {summaryOrderData?.outside_operational_charge > 0 && (
                <li>
                  <p>Midnight Surcharge</p>
                  <p>{setCurrency(summaryOrderData?.outside_operational_charge, currency)}</p>
                </li>
              )}
              {summaryOrderData?.promotion > 0 && (
                <li>
                  <p>Promo</p>
                  <p>{setCurrency(summaryOrderData?.promo_disc, currency)}</p>
                </li>
              )}
              {summaryOrderData?.public_holiday_charge > 0 && (
                <li>
                  <p>Holiday Charge</p>
                  <p>{setCurrency(summaryOrderData?.public_holiday_charge, currency)}</p>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="rental-area">
          <h3>Detail Penyewaan</h3>
          <ul className="rental-area__list-area">
            {summaryOrderData?.order_zone_price &&
              summaryOrderData.order_zone_price.map((zone, index) => (
                <li key={index + 1}>
                  <div className="desc">
                    <p>Day {index + 1} :</p>
                    <div>
                      <p className="title">lokasi :</p>
                      <p>{allAreaCharter[index]?.pickup_location_name ?? ''}</p>
                      <p className="title">Jenis Layanan :</p>
                      <p>
                        {zone?.charter_duration_label} ({zone?.charter_duration} Jam)
                      </p>
                    </div>
                  </div>
                  <p>{setCurrency(zone?.total_price, currency)}</p>
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="detail-pesanan-car-charter__action-button">
        <div className="detail-pesanan-car-charter__action-button__total-full">
          <p>Total Pembayaran</p>
          <span>
            {summaryOrderData.total_payment !== 0
              ? setCurrency(summaryOrderData.total_payment, currency)
              : setCurrency(0, currency)}
          </span>
        </div>

        {orderData?.type === 'HALF' && (
          <div className="detail-payment__action-button__total-half">
            <p>Jumlah DP {summaryOrderData.formula_percentage?.value}%</p>
            <span>
              {Object.keys(summaryOrderData).length !== 0
                ? setCurrency(summaryOrderData.total_dp, currency)
                : setCurrency(0, currency)}
            </span>
          </div>
        )}

        <div className="detail-pesanan-car-charter__action-button__buttons">
          <Button
            type="button"
            width="165px"
            height="39px"
            variant="outline"
            size="md"
            className="button"
            onClick={() => prevPage()}
          >
            Kembali
          </Button>
          <Button type="button" width="165px" height="39px" size="md" className="button" onClick={submitHandler}>
            Proses Car Charter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailPesananComponent;
